import moment from 'moment';

export const isWorkday = (date) => { return (!isHolidayBR(date) && !isWeekendBR(date)) }

const isWeekendBR = (date) => {
    let day
    day = moment(date).isoWeekday()
    return day == 6 || day == 7
}

const isHolidayBR = (date) => {
    let ano;
    let pascoa;
    let feriados;
    if (!date.isValid()) return
    ano = date.year()
    pascoa = moment(ano + Easter(ano))
    feriados = {
        '01/01': 'Ano Novo',
        '21/04': 'Tiradentes',
        '01/05': 'Dia do Trabalhador',
        '30/05': 'Corpus Christi',
        '07/09': 'Dia da Independência',
        '12/10': 'N. S. Aparecida',
        '28/10': 'Dia do Servidor Público',
        '02/11': 'Todos os Santos',
        '15/11': 'Proclamação República',
        '20/11': 'Consciência Negra',
        '25/12': 'Natal'
    }

    feriados[moment(pascoa, 'YYYYMMDD').format('DD/MM')] = 'Páscoa'
    feriados[moment(pascoa, 'YYYYMMDD').subtract(48, 'days').format('DD/MM')] = 'Segunda-feira de Carnaval'
    feriados[moment(pascoa, 'YYYYMMDD').subtract(47, 'days').format('DD/MM')] = 'Carnaval'
    feriados[moment(pascoa, 'YYYYMMDD').subtract(2, 'days').format('DD/MM')] = 'Sexta-feira Santa'
    feriados[moment(pascoa, 'YYYYMMDD').add(60, 'days').format('DD/MM')] = 'Corpus Christ'
    return feriados[moment(date, 'DD/MM/YYYY').format('DD/MM')] || false
}

const Easter = (Y) => {
    let C = Math.floor(Y / 100)
    let N = Y - (19 * Math.floor(Y / 19))
    let K = Math.floor((C - 17) / 25)
    let I = C - Math.floor(C / 4) - Math.floor((C - K) / 3) + 19 * N + 15
    I = I - (30 * Math.floor(I / 30))
    I = I - (Math.floor(I / 28) * (1 - (Math.floor(I / 28) * Math.floor(29 / (I + 1)) * Math.floor((21 - N) / 11))))
    let J = Y + Math.floor(Y / 4) + I + 2 - C + Math.floor(C / 4)
    J = J - (7 * Math.floor(J / 7))
    let L = I - J
    let M = 3 + Math.floor((L + 40) / 44)
    let D = L + 28 - (31 * Math.floor(M / 4))
    return padout(M) + '' + padout(D)
}
const padout = (number) => {

    if (number < 10) {
        return '0' + number
    } else {
        number
    }
}

// myDate = moment('02/01/2018', 'DD/MM/YYYY')
// #check feriados
// console.log isHolidayBR(myDate)

// #check finais de semana
// console.log isWeekendBR(myDate)

// #check dia util
// console.log isWorkday(myDate)